import { render, staticRenderFns } from "./proComTwo.vue?vue&type=template&id=25cf8e47&scoped=true&"
import script from "./proComTwo.vue?vue&type=script&lang=js&"
export * from "./proComTwo.vue?vue&type=script&lang=js&"
import style0 from "./proComTwo.vue?vue&type=style&index=0&id=25cf8e47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cf8e47",
  null
  
)

export default component.exports